import React, { useState } from "react";
import { Container } from 'react-bootstrap';
import axios from "axios";
import { api } from  "../services/api";
const Contact = ({translate, lang}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Form validation before submit
  const validateForm = () => {
    let errors = {};
    if (!formData.name) errors.name = "Name is required";
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Invalid email format";
    }
    if (!formData.message) errors.message = "Message cannot be empty";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        await api.post("/api/contact", formData);
        alert("Message sent successfully!");
      } catch (error) {
        console.error("Error sending message:", error);
        alert("Failed to send message.");
      }
  


    console.log("Form submitted:", formData);
    alert("Thank you for contacting us!");
    setFormData({ name: "", email: "", message: "" }); // Reset form
  };
  
};

return (
  <Container className="d-flex justify-content-center">
    <div class="card p-4 shadow">
      <form onSubmit={handleSubmit} >
        {/* Name */}
        <div className="mb-3">
          <label className="form-label">{translate('contactForm.name')}</label>
          <input
            type="text"
            name="name"
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        {/* Email */}
        <div className="mb-3">
          <label className="form-label">{translate('contactForm.email')}</label>
          <input
            type="email"
            name="email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
        </div>

        {/* Message */}
        <div className="mb-3">
          <label className="form-label">{translate('contactForm.message')}</label>
          <textarea
            name="message"
            className={`form-control ${errors.message ? "is-invalid" : ""}`}
            rows="4"
            cols="45"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          {errors.message && <div className="invalid-feedback">{errors.message}</div>}
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-primary w-100">
        {translate('contactForm.sendEmail')}
        </button>

      </form>
    </div>
  </Container>
);
};

export default Contact;
